var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:`c-button btn btn-info btn-${_vm.size} ${_vm.className}`,attrs:{"type":"button","data-beacon-article-modal":_vm.link,"data-toggle":"tooltip","title":"Show help page for this tab"}},[_c('i',{staticClass:"fa-regular fa-question-square"}),_vm._v(" Help\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }